import {TutorialBase} from "./tutorial-base";

export class PrintDocument extends TutorialBase {
  public id: string;
  public name: string;
  public uniqueName: string;
  public shortName: string;
  public sortOrderNumber: number;
  public active: boolean = true;
  public formSchema: any = {components: []};
  public sortOrder: number;
  public isExternal: boolean = false;
  public externalUrl: string;
  public pageProperties: any;
}
